// @ts-nocheck
// Greif UI Kit = fill-request-quote
import * as React from "react";

const Note: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M4.895 21q-.782 0-1.338-.529A1.7 1.7 0 0 1 3 19.2V4.8q0-.743.557-1.271A1.87 1.87 0 0 1 4.895 3h6.797q.379 0 .723.135t.603.383l4.595 4.365a1.75 1.75 0 0 1 .545 1.26v1.417a.64.64 0 0 1-.154.428.95.95 0 0 1-.39.27q-.38.135-.723.348a4 4 0 0 0-.628.484l-5.116 4.86a1.9 1.9 0 0 0-.414.574 1.6 1.6 0 0 0-.154.686v1.89q0 .383-.272.641a.94.94 0 0 1-.675.259zm7.579-.9v-1.485a.9.9 0 0 1 .284-.652l4.95-4.68a1.3 1.3 0 0 1 .474-.293q.26-.09.52-.09.285 0 .545.101t.474.304l.876.832q.19.203.296.45.107.248.107.495t-.095.507a1.2 1.2 0 0 1-.308.461l-4.926 4.68a1 1 0 0 1-.32.203q-.177.067-.367.067h-1.563a.94.94 0 0 1-.675-.259.85.85 0 0 1-.272-.641m6.229-4.14.876-.878-.876-.832-.9.855zm-6.23-6.66h3.79l-4.737-4.5v3.6q0 .383.273.641a.94.94 0 0 0 .675.259"
            />
        </svg>
    );
};

export default React.memo(Note);
